/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlAuth0Connection = {
    ControlMicrosoftOffice365: 'ControlMicrosoftOffice365',
    ControlGoogleOAuth2: 'ControlGoogleOAuth2',
    UsernamePasswordAuthentication: 'Username-Password-Authentication',
    CoalitionSaml: 'CoalitionSAML',
    CoalitionExplorerSaml: 'CoalitionExplorerSAML'
} as const;
export type ControlAuth0Connection = typeof ControlAuth0Connection[keyof typeof ControlAuth0Connection];


export function ControlAuth0ConnectionFromJSON(json: any): ControlAuth0Connection {
    return ControlAuth0ConnectionFromJSONTyped(json, false);
}

export function ControlAuth0ConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAuth0Connection {
    return json as ControlAuth0Connection;
}

export function ControlAuth0ConnectionToJSON(value?: ControlAuth0Connection | null): any {
    return value as any;
}

